import React, {useMemo, useRef, useState} from "react";
import {useAuth} from "../../../providers/AuthProvider";
import {Link, useLocation, useNavigate} from "react-router-dom";
import dateformat from "dateformat";
import ReactDOM from "react-dom";
import Form, {FormInputComponent} from "../../../components/form/Form";
import ServiceOffering from "../../../models/ServiceOffering";
import {useMount} from "react-use";

let SupplierServiceOfferingFormItemContext = React.createContext(null);

const SupplierServiceOfferingFormItemProvider = ({
    children,
    formStyle = {borderTop: `5px solid white`},
    className = '',
    model,
    isEditing,
    isUpdating,
    onEditing = () => true,
    onSave = () => true,
    itemIndex,
    itemPropName,
    displayName,
    onChange,
    ...props
}) => {
    const {auth} = useAuth();
    const navigate = useNavigate();
    const location = useLocation();

    const supplierOrg = auth?.supplierOrg();
    const [itemModel, setItemModel] = useState(() => ServiceOffering.make(({...(model || {})})));

    console.log('SupplierServiceOfferingFormItemProvider', model)
    const ItemType = 'Service Offering'
    const FormClass = 'talent-role-form add-talent-form ' + className

    const formRef = useRef(null);
    const formNameRef = useRef(null);

    // Wizard step configuration
    const wizardSteps = [
        {path: false, label: 'Name', key: 'name'},
        {path: 'services', label: 'Service Category', key: 'service_tags'},
        {path: 'overview', label: 'Overview', key: 'overview'},
        {path: 'search-tags', label: 'Search Tags', key: 'tags'},
        {path: 'deliverables', label: 'Deliverables', key: 'deliverables'},
        {path: 'faqs', label: 'FAQs', key: 'faqs'},
        {path: 'related-work', label: 'Related Work', key: 'related_work'},
    ];

    const getCurrentStepIndex = () => {

        let index = TB.findIndex(wizardSteps, step => step.path && location.pathname.includes(step.path));
        console.log('getCurrentStepIndex', index)
        if (index <= 0) {
            index = 0
        }
        return index
    };

    const currentStepIndex = getCurrentStepIndex();
    const currentStep = useMemo(() => {
        return wizardSteps[currentStepIndex] || wizardSteps[0]
    }, [currentStepIndex]);

    const creatingNewItem = () => {
        return !TB.keys(model).length
    }

    const hasChanged = () => {
        if (!model) return false;
        return false;
    }

    const monthOptions = useMemo(() => [{
        label: 'Month',
        value: '',
        disabled: false
    }].concat([
        'Jan', 'Feb', 'Mar', 'Apr', 'May', 'June', 'Jul', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'
    ].map( (month, index) => {
            return {
                label: String(month),
                value: index + 1
            };
        }
    )), [])

    const yearOptions = useMemo(() => {
        return [{
            label: 'Year',
            value: '',
            disabled: false
        }].concat(TB.rangeRight(1900, (new Date()).getFullYear() + 1)
            .map( year => {
                    return {
                        label: String(year),
                        value: year
                    };
                }
            )
        );
    }, [])

    const setDateFromInputs = (model, dateField) => {
        let newDate = model[dateField];
        let year = model[dateField + '_year'];
        let month = model[dateField + '_month'];

        if (!TB.isNaN(year) && !TB.isNaN(month)) {
            newDate = new Date(year, month - 1, 1);
        } else if (!TB.isNaN(year)) {
            newDate = new Date(year, 1, 1);
        } else if (TB.isDefined(model[dateField])) {
            newDate = undefined;
        }

        let format = 'mm-yyyy';

        if (newDate && dateformat(newDate, format) !== dateformat(model[dateField], format)) {
            return {[dateField]: newDate};
        }else if (newDate !== model[dateField]) {
            return {[dateField]: newDate};
        }
        return {};
    }

    const validateDateBeforeToday = (field, display = null) => {
        if (!display) display = TB.upperFirst(TB.lowerCase(field));

        let errors = {};
        if (itemModel[field]) {
            errors = {[field]: null};
            if (itemModel[field] > (new Date())) {
                errors[field] = display + " must be before today"
            }
        }
        return errors;
    }

    const validateDateAfterDate = (field, before_field,  error = null) => {
        if (!error) error = TB.trans('talent.school_form.validations.before_start_date');

        let errors = {};
        if(itemModel[field]) {
            errors = {[field]: null};
            if (itemModel[field] < itemModel[before_field]) {
                errors[field] = error;
            }
        }

        return errors;
    }

    const onSubmit = async() => {
        return onSave(itemModel)
    }

    const invalidFields = () => {
        if (!formRef.current){
            return false
        }
        return formRef.current.forceValidate();
    }
    const invalidNameField = () => {
        if (!formNameRef.current){
            return false
        }
        return formNameRef.current.forceValidate();
    }

    const refreshForm = async() => {
        await setItemModel(ServiceOffering.make({...model}))
        return onEditing(false);
    }

    const checkIfStepHasInvalidFields = async (key) => {
        let elem = invalidNameField();
        if (!elem) {
            elem = invalidFields();
        }

        if(elem) {
            const node = ReactDOM.findDOMNode(elem);
            $('html, body').animate({scrollTop: $(node).offset().top}, 1000);
            return true;
        }else {
            switch (key) {
                // case 'name':
                //     return itemModel?.name?.length > 0
                case 'service_tags':
                    if (!itemModel?.service_tags?.length) {
                        TB.toast('At least 1 Wripple Service is required.', {theme: 'danger'})
                        return true
                    }
                    break;
                // case 'overview':
                //     return itemModel?.name?.length > 0 && itemModel?.tag_line?.length > 0
                //         && TB.stripHtml(itemModel?.summary)?.length > 50
                //         && (!ServiceOffering.labelForFeeType(itemModel.fee_type) || itemModel.fee_amount > 0)
                case 'tags':
                    if (!itemModel?.skills?.length && !itemModel?.industries?.length && !itemModel?.disciplines?.length) {
                        TB.toast('At least 1 Role, Skill, or Industry tag is required.', {theme: 'danger'})
                        return true
                    }
                    break;
                // case 'deliverables':
                // case 'faqs':
                // case 'related_work':
                //     return true;
            }
        }
        return false;
    }

    const validateAndSave = async () => {
        let isInvalid = await checkIfStepHasInvalidFields(currentStep?.key);

        if(isInvalid) {
            return false;
        }else {
            await onSubmit()
            return true
        }
    }


    const isStepValid = (key) => {
        switch (key) {
            case 'name':
                return itemModel?.name?.length > 0
            case 'service_tags':
                return itemModel?.service_tags?.length > 0
            case 'overview':
                return itemModel?.name?.length > 0 && itemModel?.tag_line?.length > 0
                    && TB.stripHtml(itemModel?.summary)?.length > 50
                    && (!ServiceOffering.labelForFeeType(itemModel.fee_type) || itemModel.fee_amount > 0)
            case 'tags':
                return ((itemModel?.skills?.length || 0) + (itemModel?.industries?.length || 0) + (itemModel?.disciplines?.length || 0)) > 0
            case 'deliverables':
            case 'faqs':
            case 'related_work':
                return true;
        }
    }

    // Get current serviceOfferingIndex from URL
    const getCurrentServiceOfferingIndex = () => {
        const pathSegments = location.pathname.split('/');
        const serviceOfferingIndex = pathSegments.findIndex(segment => segment.match(/^\d+$/));
        return serviceOfferingIndex >= 0 ? pathSegments[serviceOfferingIndex] : null;
    };

    // Wizard navigation functions
    const goToNextStep = async () => {
        let isInvalid = await checkIfStepHasInvalidFields(currentStep?.key);
        if (isInvalid) {
            return;
        }
        const nextIndex = currentStepIndex + 1;
        if (nextIndex < wizardSteps.length) {
            const nextStep = wizardSteps[nextIndex];
            console.log('goToNextStep',nextStep.path)

            navigate(`/supplier/manage-profile/service-offerings/${itemIndex}/${nextStep.path}`);
        }
    };

    const goToPreviousStep = async () => {
        // TODO check if model has changed and alert user before navigating

        console.log('goToPreviousStep', {currentStepIndex, currentStep})
        const prevIndex = currentStepIndex - 1;
        if (prevIndex >= 0) {
            const prevStep = wizardSteps[prevIndex];
            console.log('goToPreviousStep',prevStep.path)

            if (prevStep && !prevStep.path) {
                console.log('goToPreviousStep',`/supplier/manage-profile/service-offerings/${itemIndex}` )
                navigate(`/supplier/manage-profile/service-offerings/${itemIndex}`, { replace: true });
            }else {
                navigate(`/supplier/manage-profile/service-offerings/${itemIndex}/${prevStep.path}`, { replace: true });
            }
        } else {
            let confirm = await TB.alert('warning', 'Are you sure?', 'You have unsaved changes on this page. Are you sure you want to discard your changes and leave this page?',       [
                {title: 'Yes, continue'},
                {title: 'Cancel'}
            ])
            if (confirm) {

                // Go back to the main listing
                navigate('/supplier/manage-profile/service-offerings', { replace: true });
            }
        }
    };

    const goToStep = (path) => {
        let stepIndex = TB.findIndex(wizardSteps, step => step.path === path);
        if (stepIndex >= 0 && stepIndex < wizardSteps.length) {
            const step = wizardSteps[stepIndex];
            console.log('goToStep',step.path )

            navigate(`/supplier/manage-profile/service-offerings/${itemIndex}/${step.path}`);
        }
    };

    const finishWizard = async () => {
        // Save and navigate back to main listing
        let validated = await validateAndSave();
        if (validated) {
            navigate('/supplier/manage-profile/service-offerings/');
        }
    };

    const isFirstStep = currentStepIndex <= 0;
    const isLastStep = currentStepIndex === wizardSteps.length - 1;

    const renderWizardHeader = () => {
        let visibleSteps = TB.filter(wizardSteps, step => step.key !== 'service_tags' && step.path?.length > 0);

        let currentVisibleStepIndex = TB.findIndex(visibleSteps, step => step?.key === currentStep?.key);

        console.log('renderWizardHeader', currentStep, visibleSteps, currentVisibleStepIndex)
        return (
            <div className="wizard-form-header mb-6 pb-4 border-b border-gray-200">
                {itemModel.service_tags?.length > 0 && (
                    <div className="-mx-3 -mt-3 rounded-md mb-6 border border-gray-200 p-3 from-slate-50 to-slate-100 bg-gradient-to-br flex flex-col gap-1">

                        <div className="flex flex-row items-center justify-between">
                            <p className="text-xxs font-semibold">
                                Selected Service Tags:
                            </p>
                            <Link to={'.'} onClick={e => {
                                if (isUpdating) {
                                    console.warn('saving cant navigate')
                                    e.preventDefault();
                                }
                            }} className="btn-link btn-link-info text-xxs">
                                Edit
                            </Link>
                        </div>
                        <div className="flex flex-wrap gap-2">
                            {itemModel.service_tags?.map((tag) => {
                                const IconComponent = ServiceOffering.iconForServiceCategory(tag.category_id);

                                return (
                                    <span
                                        key={tag.id}
                                        className={TB.mapClass(
                                            `inline-flex items-center gap-2 px-1.5 py-1 bg-${ServiceOffering.colorForServiceCategory(tag.category_id)}-500 text-white rounded-full text-xxs font-medium`
                                        )}
                                    >
                                        {!!IconComponent && <IconComponent className="w-3 h-3 text-white"/>}
                                        {tag.name}
                                    </span>
                                )
                            })}
                        </div>
                    </div>
                )}
                {/* Step indicator */}
                <div className="text-center text-sm text-gray-600 mb-4">
                    Step {currentVisibleStepIndex + 1} of {visibleSteps.length}: {currentStep.label}
                </div>

                {/* Step Progress Bar */}
                <div>
                    <div className="flex space-x-2">
                        {visibleSteps.map((step, index) => {

                            return (
                                <div className="flex-1 flex flex-col items-stretch gap-2" key={step.path}>
                                    <div
                                        className={`h-2 rounded cursor-pointer transition-colors
                                    ${isStepValid(step.key) ? 'cursor-pointer' : 'pointer-events-none'} ${
                                            index <= currentVisibleStepIndex
                                                ? 'bg-blue-500'
                                                : 'bg-gray-200'
                                        }`}
                                        onClick={() => {
                                            if (isStepValid(step?.key)) {
                                                goToStep(step.path)
                                            }
                                        }}
                                        title={step.label}
                                    />
                                    <span
                                        key={step.path}
                                        className={`self-center text-center ${isStepValid(step.key) ? 'cursor-pointer' : 'pointer-events-none'} ${index === currentVisibleStepIndex ? 'font-semibold text-blue-600' : ''}`}
                                        onClick={(e) => {
                                            if (isStepValid(step.key)) {
                                                goToStep(step.path)
                                            }
                                        }}
                                    >
                                        {step.label}
                                    </span>
                                </div>
                            )
                        })}
                    </div>

                </div>
            </div>
        )
    }

    const onModelChange = async (itemProps) => {
        if (!isEditing) return;
        let updates = {...itemModel}
        let formUpdates = {};
        for (let [key, value] of Object.entries(itemProps)) {
            updates = TB.set(updates, key, value)
        }

        if (onChange) {
            updates = await onChange(updates)
        }
        console.log('onModelChange', updates)
        if (itemProps.fee_type !== itemModel.fee_type) {
            formUpdates.fee_amount = null;
        }
        await setItemModel(ServiceOffering.make(updates));
        console.log('onModelChange', itemModel)
        if (TB.keys(formUpdates)?.length) {
            formRef?.current?.updateInputsWithValue(formUpdates)
        }
    }

    let value = {
        profileItem: itemModel,
        profileIndex: itemIndex,
        model,
        itemIndex,
        itemPropName,
        isEditing,
        onEditing,
        onModelChange,
        refresh: refreshForm,
        deleteItem: () => {

        },
        monthOptions,
        yearOptions,
        setDateFromInputs,
        validateDateBeforeToday,
        validateDateAfterDate,
        // Wizard specific functions
        wizardSteps,
        currentStep,
        currentStepIndex,
        goToNextStep,
        goToPreviousStep,
        goToStep,
        finishWizard,
        isFirstStep,
        isLastStep,
        renderWizardHeader
    }

    return (
        <SupplierServiceOfferingFormItemContext.Provider value={value}>
            <div className="flex flex-col gap-6 items-stretch">

                <p className="font-semibold text-base">Edit Service Offering #{itemIndex + 1}</p>
                {!isFirstStep && (
                    <div className="talent-role-form mb-0">
                        <Form
                        key={'name' + itemPropName + itemIndex + isEditing + currentStep.path}
                        ref={formNameRef}
                        title={false}
                        subtitle={null}
                        showRequired
                        submitButton={false}
                        onChange={onModelChange}
                        model={{name: itemModel?.name || ''}}
                        fields={[]}
                        className="[&_.form-container]:py-0"
                        isDisabled={isUpdating || !isEditing}>
                        <div className="flex flex-row py-3 items-center gap-3">
                            <div className="field-section flex-row gap-3 px-0 items-center">
                                <label htmlFor="name" className="whitespace-nowrap col-form-label p-0 m-0 mb-3">
                                    Service Name *
                                </label>

                                <div className="field p-0 flex-grow">
                                    <FormInputComponent
                                        fieldName="name"
                                        value={itemModel.name}
                                        type="text"
                                        label={false}
                                        placeholder="e.g., Digital Marketing Strategy"
                                        maxLength={255}
                                    />
                                </div>

                            </div>
                        </div>
                    </Form></div>
                )}
                <div className={TB.mapClass(FormClass, {
                    'active-edit': isEditing,
                    'inactive-edit': !isEditing
                })} style={formStyle}>

                    <Form
                        ref={formRef}
                        key={itemPropName + itemIndex + isEditing + currentStep.path}
                        title={false}
                        subtitle={null}
                        showRequired
                        submitButton={false}
                        onChange={onModelChange}
                        model={itemModel}
                        fields={[]}
                        isDisabled={isUpdating || !isEditing}>

                        {!isFirstStep && currentStep?.key !== 'service_tags' && renderWizardHeader()}

                        {children}

                        <div className="wizard-form-footer mt-6 py-4 border-t border-gray-200">
                            <div className="flex justify-between items-center">
                                {/* Back Button */}
                                <button
                                    className="btn btn-outline-dark"
                                    disabled={isUpdating}
                                    type="button"
                                    onClick={goToPreviousStep}
                                >
                                    {isFirstStep ? 'Back to List' : 'Back'}
                                </button>

                                <div className="flex flex-row items-center justify-end gap-3">
                                    {/* Next/Finish Button */}
                                    <button
                                        className="btn btn-primary"
                                        disabled={isUpdating}
                                        type="button"
                                        onClick={async () => {
                                            if(isLastStep) {
                                                return finishWizard()
                                            }else if (!!itemModel?.id) {
                                                await validateAndSave();
                                            }
                                            return goToNextStep();
                                        }}
                                    >
                                        {isLastStep ? 'Finish' : (!!itemModel.id ? 'Save & Continue': 'Next')}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </Form>

                </div>
            </div>
        </SupplierServiceOfferingFormItemContext.Provider>
    );
}

const useSupplierServiceOfferingFormItem = () => {
    const context = React.useContext(SupplierServiceOfferingFormItemContext);
    if (!context) {
        throw new Error('useSupplierServiceOfferingFormItem must be used within a SupplierServiceOfferingFormItemProvider');
    }
    return context;
}

export default SupplierServiceOfferingFormItemProvider;
export {
    useSupplierServiceOfferingFormItem,
    SupplierServiceOfferingFormItemContext
}